import axios from 'axios';


// Forzar URL vacía para usar proxy de Apache
const api = axios.create({ baseURL: '' });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    // Cuenta desactivada: el token sigue firmado pero ya no vale. Sin esto el
    // usuario se queda dando vueltas en un panel donde todo falla.
    if (error.response?.status === 403 &&
        error.response?.data?.detail === 'Usuario desactivado') {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const login = (username, password) => api.post('/api/auth/login', { username, password });
export const getMe = () => api.get('/api/auth/me');
export const changeMyPassword = (current_password, new_password) =>
  api.post('/api/auth/change-password', { current_password, new_password });

// --- Usuarios, roles y permisos (RBAC, migración 0009) ---
export const getUsers = () => api.get('/api/users');
export const getUser = (id) => api.get(`/api/users/${id}`);
export const createUser = (data) => api.post('/api/users', data);
export const updateUser = (id, data) => api.put(`/api/users/${id}`, data);
export const deactivateUser = (id) => api.delete(`/api/users/${id}`);
export const resetUserPassword = (id, new_password) =>
  api.post(`/api/users/${id}/password`, { new_password });

export const getRoles = () => api.get('/api/roles');
export const createRole = (data) => api.post('/api/roles', data);
export const updateRole = (id, data) => api.put(`/api/roles/${id}`, data);
export const deleteRole = (id) => api.delete(`/api/roles/${id}`);

export const getPermissions = () => api.get('/api/permissions');

export const getDevices = () => api.get('/api/devices');
export const getDevice = (deviceId) => api.get(`/api/devices/${deviceId}`);
export const createDevice = (data) => api.post('/api/devices', data);
export const updateDevice = (id, data) => api.put(`/api/devices/${id}`, data);
export const deleteDevice = (id) => api.delete(`/api/devices/${id}`);

export const getPendingDevices = () => api.get('/api/devices/pending/list');
export const approvePendingDevice = (id, data) => api.post(`/api/devices/pending/${id}/approve`, data);
export const deletePendingDevice = (id) => api.delete(`/api/devices/pending/${id}`);

export const getLatestSnapshot = (deviceId, channel = 1) => 
  api.get(`/api/devices/${deviceId}/snapshot?channel=${channel}`, { responseType: 'blob' });
export const getLatestSnapshotBase64 = (deviceId, channel = 1) => 
  api.get(`/api/devices/${deviceId}/snapshot/base64?channel=${channel}`);
export const getDeviceSnapshots = (deviceId, channel = null, limit = 50) => {
  let url = `/api/devices/${deviceId}/snapshots?limit=${limit}`;
  if (channel) url += `&channel=${channel}`;
  return api.get(url);
};
export const triggerCapture = (deviceId, channel = null) => {
  let url = `/api/devices/${deviceId}/capture`;
  if (channel) url += `?channel=${channel}`;
  return api.post(url);
};

// Estado de las capturas (pagina Capturas, migracion 0011)
export const getCapturesStatus = (deviceId = null) =>
  api.get('/api/captures/status' + (deviceId ? `?device_id=${encodeURIComponent(deviceId)}` : ''));
export const getCapturesErrors = (deviceId = null, limit = 200) =>
  api.get(`/api/captures/errors?limit=${limit}` + (deviceId ? `&device_id=${encodeURIComponent(deviceId)}` : ''));

export const getPanelEvents = (account = null, limit = 100) => {
  let url = `/api/panel/events?limit=${limit}`;
  if (account) url += `&account=${account}`;
  return api.get(url);
};
export const getPanelAlarms = () => api.get('/api/panel/alarms');

export const getMdvrLan = (sucursal = null) =>
  api.get('/api/mdvr/lan' + (sucursal ? `?sucursal=${encodeURIComponent(sucursal)}` : ''));
export const readMdvrWifi = (deviceId) => api.get(`/api/mdvr/${deviceId}/wifi`);
export const setMdvrWifi = (deviceId, data) => api.post(`/api/mdvr/${deviceId}/wifi`, data);
export const bulkMdvrWifi = (data) => api.post('/api/mdvr/wifi/bulk', data);

export const getVmsCamaras = (sucursal = null) =>
  api.get('/api/vms/camaras' + (sucursal != null ? `?sucursal=${sucursal}` : ''));

export const getConfig = () => api.get('/api/config');
export const updateConfig = (data) => api.put('/api/config', data);
export const getStatus = () => api.get('/api/status');
export const getOnlineStatus = () => api.get('/api/status/devices');

export default api;
